export default __webpack_public_path__ + "static/media/Iowa_State_ITS.67f36f2c.png";